import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CustomMessageEntity } from '../../domain/entities/CustomMessageEntity'
import type { CustomMessageAdminDto } from '@/backend/market'

export class CustomMessageModel extends CustomMessageEntity {
  constructor(dataDto: CustomMessageAdminDto) {
    super()
    mapEntityProperties<CustomMessageModel>(this, dataDto)
  }
}
